<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="dialogClose" width="1050px">
    <div class="right mb10">
      <el-button type="primary" size="mini" v-print="'#print'">打印</el-button>
    </div>
    <div id="print">
      <el-table ref="registerTable" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" :span-method="objectSpanMethod">
        <el-table-column prop="type" label="项目（数量、计量单位）" align="center" />
        <el-table-column label="业务量情况" align="center">
          <el-table-column prop="transport2" label="非多式联运" align="center" />
          <el-table-column prop="transport" label="多式联运" align="center" />
        </el-table-column>
        <el-table-column label="运营情况" align="center">
          <el-table-column prop="value" label="营业收入（不含税-万元）" align="center" />
          <el-table-column prop="netProfit" label="净利润（万元）" align="center" />
          <el-table-column prop="personnelNumber" label="期末员工数（人）" align="center" />
          <el-table-column label="实体单位填报" align="center">
            <el-table-column prop="turnover" label="运输周转量（吨公里）" align="center" />
            <el-table-column prop="distance" label="运输里程（公里）" align="center" />
            <el-table-column prop="meteringCompany" label="能耗种类、数量、计量单位（吨、立方、度等）" align="center" />
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="right mb10">
        <p class="summary-info">负责人签字：{{ tableData[0] ? tableData[0].submitter : '' }}</p>
        <p class="summary-info">提交时间：{{ tableData[0] ? tableData[0].submitTimeExport : '' }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { monthlySummaryDetails, monthlySummaryUpdate, updateShipTracking } from '@/service/financial';

  export default {
    name: 'yearAndMonthSummaryInfo',
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        submitLoading: false,
      };
    },
    methods: {
      // 合并相同列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          // {
          //   columnIndex: 3,
          // },
          // {
          //   columnIndex: 4,
          // },
          {
            columnIndex: 5,
            value: "personnelNumber",
          },
          // {
          //   columnIndex: 6,
          // },
          // {
          //   columnIndex: 7,
          // },
          // {
          //   columnIndex: 8,
          // },
        ];
        // console.log(this.filterData(this.tableData, data[0].value));
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            // const _row = this.filterData(this.tableData, data[1].value)[rowIndex];
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      async dialogOpen(id) {
        const { status, message, data } = await monthlySummaryDetails(id);
        this.$emit('infoLoading');
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            const { status, message } = await monthlySummaryUpdate(this.form);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-dialog__body {
      padding: 10px !important;
    }
  }

  .summary-info {
    padding-right: 350px;
    font-size: 16px;
    font-weight: bold;
  }

  .summary-info:first-child {
    padding-top: 60px;
  }
</style>
